"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PurchaseTerms = require("./PurchaseTerms");
Object.keys(_PurchaseTerms).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PurchaseTerms[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PurchaseTerms[key];
    }
  });
});